import { render, staticRenderFns } from "./AndiamoAccessiListPage.vue?vue&type=template&id=b816a282&scoped=true"
import script from "./AndiamoAccessiListPage.vue?vue&type=script&lang=js"
export * from "./AndiamoAccessiListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b816a282",
  null
  
)

export default component.exports